import { CreditAdjustmentResponse, CustomerCreditStatement, ExchangeList, ExchangeResponse, OldManagementAccountResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/** O filtro como query string, com o `?` — vazio sem filtro. */
export const exchangeParams = (filter) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filter)) {
        if (value !== undefined)
            params.set(key, String(value));
    }
    const query = params.toString();
    return query === '' ? '' : `?${query}`;
};
export const fetchExchanges = async (filter = {}, signal) => ExchangeList.parse(await request(`/api/v1/exchanges${exchangeParams(filter)}`, {
    ...(signal ? { signal } : {}),
}));
export const fetchExchange = async (id, signal) => ExchangeResponse.parse(await request(`/api/v1/exchanges/${id}`, { ...(signal ? { signal } : {}) }));
export const createExchange = async (input) => ExchangeResponse.parse(await request('/api/v1/exchanges', { method: 'POST', body: input }));
/** O saldo de vale de um cliente e o extrato que o explica. */
export const fetchCustomerCredit = async (partyId, signal, page) => CustomerCreditStatement.parse(await request(`/api/v1/exchanges/customers/${partyId}/credit${page === undefined
    ? ''
    : `?page=${String(page.page)}&pageSize=${String(page.pageSize)}`}`, { ...(signal ? { signal } : {}) }));
/** O caixa (ou o vendedor) pede ao trocador (fatia 2d). */
export const createExchangeRequest = async (input) => ExchangeResponse.parse(await request('/api/v1/exchanges/requests', { method: 'POST', body: input }));
/** O trocador recusa o pedido, com motivo. */
export const rejectExchangeRequest = async (id, reason) => ExchangeResponse.parse(await request(`/api/v1/exchanges/${id}/reject`, {
    method: 'POST',
    body: { reason },
}));
/**
 * Dá ou tira vale do cliente na mão (F216). `authorisationId` é a senha do
 * dono ou do admin, aprovando exatamente este ajuste.
 */
export const adjustCustomerCredit = async (partyId, input) => CreditAdjustmentResponse.parse(await request(`/api/v1/exchanges/customers/${partyId}/credit/adjustments`, {
    method: 'POST',
    body: input,
}));
/** A conta com a gestão antiga: emitido, já usado (a cobrar) e em aberto. */
export const fetchOldManagementAccount = async (signal) => OldManagementAccountResponse.parse(await request('/api/v1/exchanges/old-management', {
    ...(signal ? { signal } : {}),
}));
//# sourceMappingURL=exchanges.js.map